import React, { Component } from 'react'

export default class Loader extends Component {
  render() {
    return (
      <div>
        <div className="jobsBar">LOADING</div>
        <div className="jobLoading">
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/util/Loader.js